<div class="page-content">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

     <h1 class="page-title" translate>{{'CCB_are_you_sure.page_title'}}</h1>
     
     <div translate='CCB_are_you_sure.needToDo_1'></div>
     <ol>
           <li translate='CCB_are_you_sure.needToDo_1_li_1'></li>
           <li translate='CCB_are_you_sure.needToDo_1_li_2'></li>
           <li translate='CCB_are_you_sure.needToDo_1_li_3'></li>
     </ol>
     <span translate='CCB_are_you_sure.needToDo_2'></span>
     <a-link link-url="CCB_are_you_sure.accountLinkURL" 
                        alt-text="CCB_are_you_sure.accountLink_alt" 
                        label='CCB_are_you_sure.accountLink'></a-link>
     <span translate='CCB_are_you_sure.needToDo_3'></span>
     
     <div class="btn-div">
      <div class="button-top"> <button class="btn-next2" title="{{'CCB_are_you_sure.backToBT_alt'|translate}}" (click)="onPreviousClick()" translate>{{'CCB_are_you_sure.backToBT'}}</button></div>
      <div class="button-bottom"><button class="btn-cancel2" title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>{{Button.Next}}</button></div>
     </div>
</div>
